import React from 'react';

import { isEmpty } from 'lodash';

import moment from 'moment';

import { getTimeZoneAbbr } from '../helpers/timezones';

import * as classes from './InspectionReportGrid.module.css';

const InspectionReportGrid = ({
    data,
    label,
    ...props
}) => {

    const renderFault = fault => {
        if (fault) {
            return 'Y';
        } else {
            return 'N';
        }
    };

    const zone = moment.tz.guess();

    const renderTotalHours = hours => {
        if (hours > 0 && hours < 1) {
            return '< 1 Hour'; 
        } else {
            return Math.round(hours) + ' Hours';
        }
    };

    return (
        <React.Fragment>
            {
                isEmpty(data) ?
                    <div>
                        {
                            label.toLowerCase() === 'equipment' ?
                                'No Impacted Equipment in Fault'
                                :
                                'No Impacted System in Fault'
                        }
                    </div>
                    :
                    <table className={classes.Table}>
                        <thead>
                            <tr>
                                <th className={classes.Blank} />
                                <th className={classes.PreviousHeader} colSpan="3">Previous Period</th>
                                <th className={classes.CurrentHeader} colSpan="3">Current Period</th>
                            </tr>
                            <tr>
                                <th className={classes.Label}>{label}</th>
                                <th>Fault</th>
                                <th>Time in Fault</th>
                                <th>Last Time in Fault</th>
                                <th>Fault</th>
                                <th>Time in Fault</th>
                                <th>Last Time in Fault</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.map((item, index) => {
                                return (
                                    <tr key={index}>
                                        <td className={classes.Name}>
                                            {item.ImpactedItemName ? item.ImpactedItemName : `${label} Name `}
                                        </td>
                                        <td className={classes.Fault}>
                                            {renderFault(item.priorFault)}
                                        </td>
                                        <td>
                                            {item.priorFault ? renderTotalHours(item.priorTotalHours) : ''}
                                        </td>
                                        <td>
                                            {item.priorLastFaultTime && !item.priorLastFaultTime.includes('0001-01-01T00:00:00') ? moment(item.priorLastFaultTime).utc().local().format('YYYY-MM-DD HH:mm') + ' ' + getTimeZoneAbbr(moment(item.priorLastFaultTime), zone) : ''}
                                        </td>
                                        <td className={classes.Fault}>
                                            {renderFault(item.currentFault)}
                                        </td>
                                        <td>
                                            {item.currentFault ? renderTotalHours(item.currentTotalHours) : ''}
                                        </td>
                                        <td>
                                            {item.currentLastFaultTime && !item.currentLastFaultTime.includes('0001-01-01T00:00:00') ? moment(item.currentLastFaultTime).utc().local().format('YYYY-MM-DD HH:mm') + ' ' + getTimeZoneAbbr(moment(item.currentLastFaultTime), zone) : ''}
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
            }
        </React.Fragment>
    );
};

export default InspectionReportGrid;
